import moment from "moment";

let func = {
   sleep(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
   },
   tsFormat(ts, format) {
      if (!func.isDefined(format)) {
         format = "YYYY-MM-DD HH:mm";
      }
      return moment.unix(ts).format(format);
   },
   dateFormat(date, format) {
      return moment.unix(date.getTime() / 1000).format(format);
   },
   isFuture: (ts) => new Date().getTime() < (ts * 1000),
   formatCNY: (value) => "￥" + value.toFixed(2),
   formatCNF: (value) => "￥" + (value / 100).toFixed(2),
   imageUrl(id, args, local) {
      let query = func.obj2Query(args);
      local = func.isDefined(local) ? local : false;
      let host = local ? "http://localhost" : process.env.VUE_APP_RESOURCE;
      return (query !== "") ? `${host}/images/${id}?${query}` : `${host}/images/${id}`;
   },
   getData(url, type) {
      return new Promise(function (resolve, reject) {
         let xhr = new XMLHttpRequest();
         xhr.responseType = type;
         xhr.open("get", url, true);
         xhr.onload = () => {
            resolve(xhr.response);
         };
         xhr.onerror = reject;
         xhr.send(); // send request
      });
   },
   imageSize(url) {
      return new Promise(function (resolve, reject) {
         let img = new Image();
         img.onload = function () {
            resolve({w: img.width, h: img.height});
         };
         img.onerror = reject;
         img.src = url;
      });
   },
   copyObject(value) {
      return JSON.parse(JSON.stringify(value));
   },
   obj2Query(args) {
      let parts = [];
      for (let key in args) {
         func.isDefined(args[key]) &&
         parts.push(`${key}=${args[key]}`)
      }
      return parts.join("&")
   },
   trimSuffix(fileName) {
      return fileName.substring(0, fileName.lastIndexOf("."));
   },
   maskString(str, from, length) {
      let mask = "";
      for (let i = 0; i < length; i++) mask += "*";
      return str.substr(0, from) + mask + str.substr(from + length, str.length);
   },
   isWeiXin() {
      return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
   },
   isMobile(mobile) {
      return /^(?:\+?86)?1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[01356789]\d{2}|4(?:0\d|1[0-2]|9\d))|9[189]\d{2}|6[567]\d{2}|4[579]\d{2})\d{6}$/.test(mobile);
   },
   hasMetaTitle(item) {
      return typeof item.meta !== "undefined"
         && typeof item.meta.title !== "undefined"
         && item.meta.title !== "" && item.meta.title !== null;
   },
   getScrollWidth() {
      let div1 = document.createElement("div");
      let div2 = document.createElement("div");
      div1.style.cssText = "overflow-y:scroll; width:100px; visibility:hidden";
      div2.style.cssText = "overflow-y:hidden; width:100%; visibility:hidden";
      div1.appendChild(div2);
      document.body.appendChild(div1);
      let width1 = div1.offsetWidth;
      let width2 = div2.offsetWidth;
      document.body.removeChild(div1);
      return (width1 - width2 > 0 ? (width1 - width2) : 17) + 1;
   },
   computedColWidth(cfg) {
      let width = cfg.width;
      let count = cfg.count;
      const {gutter, range} = cfg;
      let colWidth = (width - ((count - 1) * gutter)) / count;
      while (colWidth > range[1]) {
         count += 1;
         colWidth = (width - ((count - 1) * gutter)) / count;
      }
      while (colWidth < range[0]) {
         count -= 1;
         colWidth = (width - ((count - 1) * gutter)) / count;
      }
      return colWidth;
   },
   isObject: (value) => typeof value === 'object',
   isDefined: (value) => typeof value !== 'undefined',
   setTimeout: (delay, func) => setTimeout(func, delay),
   bytes2GB: (value) => (value / 1024 / 1024 / 1024).toFixed(2),
   bytesAuto(value) {
      if (!value) return "0 KB";
      let kb = (value / 1024).toFixed(1);
      let mb = (value / 1024 / 1024).toFixed(2);
      let gb = (value / 1024 / 1024 / 1024).toFixed(3);
      return gb > 1 ? `${gb}GB` : (mb >= 1 ? `${mb} MB` : `${kb} KB`);
   },
   emptyObject(object, value) {
      value = func.boolStrict(value);
      for (let key in object) {
         if (!value) {
            return false;
         }
         if (object[key]) {
            return false;
         }
      }
      return true;
   },
   mapAppend(src, data) {
      for (let key in data) src[key] = data[key];
      return src;
   },
   arrayAppend(src, data) {
      data.forEach(item => {
         src.push(item);
      });
      return src;
   },
   arraySwap(data, idx1, idx2) {
      data[idx1] = data.splice(idx2, 1, data[idx1])[0];
   },
   intStrict(value) {
      return func.isDefined(value) ? value : 0;
   },
   boolStrict(value) {
      return func.isDefined(value) ? value : false;
   },
   stringStrict(value) {
      return func.isDefined(value) ? value : "";
   },
   countByKey(array, key) {
      let count = 0;
      for (let i in array) {
         count += array[i][key]
      }
      return count
   },
   getByKey(array, key) {
      let values = [];
      for (let i in array) {
         values.push(array[i][key]);
      }
      return values;
   },
   mapKeys(data) {
      let keys = [];
      for (let key in data) {
         keys.push(key);
      }
      return keys;
   },
   extension(filename) {
      let index = filename.lastIndexOf(".") + 1;
      return filename.substring(index, filename.length);
   },
};

export default func;
